<template>
  <b-container v-if="this.$root.signedIn">
    <br>
    <b-row v-show="!this.loading">
      <b-col>
        <b-row class="pb-2">
          <b-col class="text-left text-nowrap" cols=3>Year(s)</b-col>
          <b-col>
            <multiselect v-model="years" :options="yearList" :multiple="true" :close-on-select="false" :placeholder="'All'"/>
          </b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col class="text-left text-nowrap" cols=3>Programme(s)</b-col>
          <b-col>
            <multiselect v-model="programmes" :options="programmeList" :multiple="true" :close-on-select="false" track-by="id" label="name" :placeholder="'All'"/>
          </b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col class="text-left text-nowrap" cols=3>Industry(s)</b-col>
          <b-col>
            <multiselect v-model="industries" :options="industryList" :multiple="true" :close-on-select="false" :placeholder="'All'" :select-label="''" :deselect-label="''"/>
          </b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col class="text-left text-nowrap" cols=3>Customer(s)</b-col>
          <b-col>
            <multiselect v-model="customers" :options="customerList" :multiple="true" :close-on-select="false" track-by="id" label="name" :placeholder="'All'"/>
          </b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col class="text-left text-nowrap" cols=3>Country(s)</b-col>
          <b-col>
            <multiselect v-model="countries" :options="countryList" :multiple="true" :close-on-select="false" :placeholder="'All'"/>
          </b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col class="text-left text-nowrap" cols=3>Region(s)</b-col>
          <b-col>
            <multiselect v-model="regions" :options="regionList" :multiple="true" :close-on-select="false" :placeholder="'All'" group-values="regions" group-label="country" :group-select="true"/>
          </b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col>
            <b-btn variant="primary" @click="calculateData()">Show</b-btn>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin v-show="loadingData"/>
        <gear-industry-bar v-if="chartData" :chart-data="chartData" :survey-runs="surveyRuns" :width="500"/>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// @ is an alias to /src
import {industries, countries, regions} from '@/services/constants';
import * as _ from 'lodash';
import * as API from '@/services/API';
import * as Reporting from '@/services/Reporting';
import GearIndustryBar from '@/graphs/GearIndustryBar';

export default {
  name: "IndustryScoreGearBars",
  components: {
    GearIndustryBar
  },
  computed: {
    
  },
  watch: {
    countries: function(val) {
      this.regionList = this.getRegions(val);
    }
  },
  created () {
    this.init();
  },
  data: function() {
    return {
      customerList: [],
      industryList: industries,
      programmeList: [],
      countryList: countries,
      regionList: [],
      yearList: [],
      years: [],
      customers: [],
      industries: [],
      programmes: [],
      countries: [],
      regions: [],
      chartData: null,
      surveyRuns: [],
      showCriteria: true,
      loading: true,
      loadingData: false
    }
  },
  methods: {
    init() {
      this.regionList = this.getRegions(null);
      const thisYear = new Date().getFullYear();
      this.years = [thisYear];
      const startYear = 2011;
      for (let i = 0; i < thisYear - startYear; i++) {
        this.yearList.push(thisYear - i);
      }

      this.loading = true;
      return Promise.all([
        API.getCustomers().then(results => this.customerList = results.results),
        API.getProgrammes().then(results => this.programmeList = results.results)
      ]).then(() => { this.loading = false; });
    },
    getRegions(countries) {
      return Object.keys(regions).map((country) => {
        return {
          country,
          regions: regions[country]
        };
      }).filter(x => (!countries || countries.length === 0 || countries.indexOf(x.country) != -1))
    },
    calculateData() {
      this.loadingData = true;
      this.showCriteria = false;

      // make queries
      const query = {};
      if (this.customers && this.customers.length > 0) query.customer_id = this.customers.map(customer => customer.id);
      if (this.regions && this.regions.length > 0) query["customer_id:Customer.region"] = this.regions;
      if (this.programmes && this.programmes.length > 0) query.programme_id = this.programmes.map(programme => programme.id);
      if (this.countries && this.countries.length > 0) query["customer_id:Customer.country"] = this.countries;
      if (this.industries && this.industries.length > 0) query["customer_id:Customer.industry"] = this.industries;
      if (this.years && this.years.length > 0) query.year = this.years;

      // get
      return Reporting.getScores({where: query}).then(results => {
        if (!results[0]) results[0] = {};
        this.chartData = {overall: {
          average:  results[0].averageScore,
          minimum:  results[0].minScore,
          maximum:  results[0].maxScore
        }}
        this.loadingData = false;
      });
    }
  }
}
</script>
<style>
.vue-js-switch#gears-or-scores {
  font-size: 16px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/IndustryScoreGearBars.vue